<template>
  <div class="product-tabs">
    <div class="product-tabs__triggers">
      <button
        type="button"
        class="button-reset product-tabs__trigger"
        :class="{ 'product-tabs__trigger--active': activeTabIndex === 0 }"
        @click="activeTabIndex = 0"
      >
        {{ $t('Description') }}
      </button>

      <button
        type="button"
        class="button-reset product-tabs__trigger"
        :class="{
          'product-tabs__trigger--active': activeTabIndex === 1,
        }"
        @click="activeTabIndex = 1"
      >
        {{ $t('Delivery / Payment') }}
      </button>
    </div>

    <div v-show="activeTabIndex === 0" class="product-tabs__tab">
      <p class="product-description" itemprop="description">
        {{ productDescription }}
      </p>
    </div>

    <div v-show="activeTabIndex === 1" class="product-tabs__tab">
      <div class="product-delivery-and-payment">
        <div class="delivery-item product-delivery-and-payment__item">
          <div class="delivery-item__icon">
            <i class="icon-truck" />
          </div>

          <div class="delivery-item__address">
            <p v-if="deliveryAddress">{{ $t('Delivery to address') }} {{ warehouseAddressString(deliveryAddress) }}</p>

            <p v-else>
              {{ $t('Delivery available') }}
            </p>

            <span>{{ $t('Delivery is carried out by the seller') }}</span>
          </div>
        </div>

        <div class="delivery-item product-delivery-and-payment__item">
          <div class="delivery-item__icon">
            <i class="icon-truck" />
          </div>

          <div class="delivery-item__address">
            <p v-if="pickupAddress">
              {{ $t('Pickup at address') }} {{ warehouseAddressString(pickupAddress, { withAddress: false }) }}
            </p>
            <p v-else>
              {{ $t('Pickup available') }}
            </p>

            <span>
              {{ $t('Pickup at the collection point address') }}.
              <span v-if="pickupAddress"> {{ $t('You may choose another pick-up point') }}. </span></span
            >
          </div>
        </div>

        <div class="delivery-item product-delivery-and-payment__item">
          <div class="delivery-item__icon">
            <i class="icon icon-purse" />
          </div>

          <div class="delivery-item__address">
            <p>
              {{ $t('Payment by cash or non-cash methods') }}
            </p>

            <span>
              {{ $t('Delayed payment available') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { warehouseAddressString } from '@/helpers/warehouseAddressString'
import { Truck, Wallet } from 'lucide-vue'

export default {
  name: 'ProductPageTabs',
  components: {
    Truck,
    Wallet,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    deliveryAddress: {
      type: Object,
      required: false,
    },
    pickupAddress: {
      type: Object,
      required: false,
    },
  },
  data: () => ({
    activeTabIndex: 0,
  }),
  computed: {
    productDescription() {
      const { product, sort, country, category, extra_info, description } = this.product

      if (extra_info) {
        return extra_info
      }

      if (description) {
        return description
      }

      return `Купите ${product.name} ${sort.name} – ${
        country.name
      }, ${category.name.toLowerCase()} по лучшей цене! Доставка до двери или самовывоз из ПВЗ.`
    },
  },
  methods: {
    warehouseAddressString,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.product-tabs {
  background-color: $White;
  border-radius: 4px;
  padding: 10px 12px;

  @include media-breakpoint-up(xl) {
    padding: 20px 30px;
    border-radius: 8px;
  }

  &__triggers {
    display: flex;
    gap: 10px;

    @include media-breakpoint-up(xl) {
      gap: 24px;
    }
  }

  &__trigger {
    font-size: 13px;
    line-height: 1.16;
    font-weight: 600;
    border-bottom: 2px solid transparent;
    transition: border-bottom-color 200ms ease-in-out;
    padding-bottom: 6px;

    @include media-breakpoint-up(xl) {
      font-size: 16px;
      line-height: 18px;
      border-bottom: 4px solid transparent;
      padding-bottom: 12px;
    }

    &--active {
      border-bottom-color: $GreenM;
    }
  }

  &__tab {
    padding-top: 10px;

    @include media-breakpoint-up(xl) {
      padding-top: 20px;
    }
  }
}

.delivery-item {
  display: grid;
  gap: 8px;
  grid-template-columns: 18px 1fr;
  font-size: 14px;
  line-height: 1.17;

  @include media-breakpoint-up(xl) {
    font-size: 16px;
    line-height: 21px;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $Gray2;
    font-size: 14px;

    @include media-breakpoint-up(xl) {
      font-size: 16px;
    }
  }

  &__address {
    font-weight: 500;
    display: flex;
    flex-direction: column;

    span {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;

      @include media-breakpoint-up(xl) {
        font-size: inherit;
        line-height: inherit;
      }
    }
  }
}

.product-delivery-and-payment {
  display: grid;
  gap: 18px;

  @include media-breakpoint-up(xl) {
    gap: 36px;
  }

  &__item {
    position: relative;

    &:not(:last-child)::after {
      content: '';
      display: block;
      width: 100%;
      height: 1px;
      bottom: -9px;
      background-color: $LGray3;
      position: absolute;

      @include media-breakpoint-up(xl) {
        bottom: -18px;
      }
    }
  }
}

.product-description {
  font-size: 13px;
  line-height: 1.2;
  color: $DGray;

  @include media-breakpoint-up(xl) {
    font-size: 16px;
    line-height: 18px;
  }
}
</style>
